import React, { useState } from 'react'
import SectionsApp, { ISectionModel } from '../sections/SectionsApp'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { addNewSection, deleteSection, updateAllSections, updateSectionsLoadingStatus, updateSectionsPagination, updateSectionsSearch, useReturnAllSections, useReturnSectionsLoadingStatus, useReturnSectionsPagination, useReturnSectionsSearch, useReturnSectionsSearchParams, useReturnSelectedSections } from '../sections/sectionsSlice'
import { ISearchParam } from '../BaseApp'
import { handleRequestError } from '../../services/api'
import { updateQuickNotificationDetails } from '../notifications/notificationsSlice'
import { IAxiosDefaultDataObject } from '../../config'
import AdminDynamicBasePage from '../admin/AdminDynamicBasePage'
import { IDataDisplyerItemActionOption } from '../../components/DataDisplayer/DataDisplayer'
import { IDynamicForm } from '../../components/Form/DynamicForm'
import AdminGridDataBasePage from '../admin/AdminGridDataBasePage'
import GridData from '../../components/GridData/GridData'
import { IGridHeaderOption } from '../../components/GridData'
import NewSectionModal from '../sections/NewSectionModal'

interface IWarehouseSectionsListProps {
    warehouseId: number
}

export default function WarehouseSectionsList(props: IWarehouseSectionsListProps) {

    const {
        warehouseId
    } = props

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const sections = useReturnAllSections()
    const pagination = useReturnSectionsPagination()
    const loading = useReturnSectionsLoadingStatus()
    const search = useReturnSectionsSearch()
    const searchParams = useReturnSectionsSearchParams()
    const selectedSections = useReturnSelectedSections()

    const sectionsApp = new SectionsApp()

    const [newSectionModalOpenStatus, setNewSectionModalOpenStatus] = useState<boolean>(false)

    /**
     * Handle open new section modal
     */
    const handleOpenNewSectionModal = () => setNewSectionModalOpenStatus(true)

    /**
     * Handle close new section modal
     */
    const handleCloseNewSectionModal = () => setNewSectionModalOpenStatus(false)

    /**
     * Update loading status
     */
    const updateLoadingStatus = (status: boolean) => dispatch(updateSectionsLoadingStatus({ loading: status }))

    /**
     * Filter Form
     */
    const headerOptions: IGridHeaderOption[] = sectionsApp.gridDataEssentials.headerOptions ? sectionsApp.gridDataEssentials.headerOptions :[]

    /**
     * Handle load sections
     */
    const handleLoadSections = (page: number, search: string|null, disablePagination: boolean, addItems?: boolean, searchParams?: ISearchParam[]) => {

        let searchParamsList: ISearchParam[] = searchParams ? searchParams : []

        return sectionsApp.listOfInstances(page, search, disablePagination, addItems, [
            ...searchParamsList,
            {
                name: "warehouse_id",
                value: warehouseId
            }
        ])
    }

    /**
     * Handle on success new section
     */
    const handleOnSuccessNewSection = () => {
        // handleLoadSections(1, search ? search : "", false)
        handleCloseNewSectionModal()
    }

    return(
            <div>
                <NewSectionModal
                    open={newSectionModalOpenStatus}
                    handleClose={handleCloseNewSectionModal}
                    warehouseId={warehouseId}
                    handleOnSuccess={handleOnSuccessNewSection}
                />

                <GridData 
                    items={sections}
                    columns={sectionsApp.gridDataColumns}
                    selectedItems={selectedSections}
                    pagination={pagination}
                    search={search ? search : ""}
                    searchParams={searchParams}
                    loading={loading}
                    actionButtons={sectionsApp.gridDataEssentials.actionButtons}
                    headerOptions={[
                        ...headerOptions,
                        {
                            label: "New Section",
                            icon: "new",
                            onClick: () => handleOpenNewSectionModal()
                        }
                    ]}
                    handleLoadItems={handleLoadSections}
                    updateSearch={(search) => {
                        if (sectionsApp.dynamicBasePage?.updateSearch){
                            sectionsApp.dynamicBasePage.updateSearch(search, dispatch)
                        }
                    }}
                    setSelectedItems={(items) => {
                        if (sectionsApp.gridDataEssentials?.setSelectedItems){
                            sectionsApp.gridDataEssentials?.setSelectedItems(items, dispatch)
                        }
                    }}
                    onDeleteItem={(id) => sectionsApp.deleteInstance(id)}
                    onDeleteManyItems={(records) => sectionsApp.deleteManyInstances(records)}
                    deleteItem={(id, dispatch) => sectionsApp.dynamicBasePage?.deleteItem(id, dispatch)}
                    updateLoading={(status) => sectionsApp.dynamicBasePage?.updateLoadingStatus(status, dispatch)}
                    updateItemSearchParams={(params) => sectionsApp.gridDataEssentials?.updateItemSearchParams(params, dispatch)}
                    addNewItem={(item, dispatch) => sectionsApp.dynamicBasePage?.addNewItem(item, dispatch)}
                    updateItem={(item, dispatch) => sectionsApp.dynamicBasePage?.updateItem(item, dispatch)}
                    updateAllItems={(items, dispatch) => sectionsApp.dynamicBasePage?.updateAllItems(items, dispatch)}
                    updateItemsPagination={(pagination, dispatch) => sectionsApp.dynamicBasePage?.updateItemsPagination(pagination, dispatch)}
                    config={{
                        ...sectionsApp.gridConfig,
                        filterForm: undefined
                    }}
                    nothingFoundMessage={sectionsApp.messages.nothingFound}
                />
            </div>
    )
}